import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import selectors from './selectors';

const options = {
  name: 'memberships',
  baseType: 'MEMBERSHIPS',
  apiEndpoint: 'memberships',
  defaultSortBy: 'display_order'
};

const operations = createMetadataAPIOperations(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
